import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Partners, Banner, Destinations, Tours, Pricing, Offers, HomeSearch, PortfolioSection, TourCategory } from '../../sections';


const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <HomeSearch /> {/* Home Search Section */}
      <About /> {/* About Section */}
      <Services /> {/* Services Section */}
      <Counter /> {/* Counter Section */}
      <Destinations /> {/* Destination Section */}
      <Tours /> {/* Popular Tours Slider */}
      <Banner /> {/* Banner Section */}
      <TourCategory /> {/* top 5 Tour Categories */}
      <PortfolioSection /> {/* Portfolio Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Pricing /> {/* Pricing Section */}
      <Offers /> {/* Offers Slider */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;